import { DownCaratIcon } from 'foundations-assets';
import { Button } from 'foundations-components/transitional/components/Button';
import { Popover } from 'foundations-components/transitional/components/Popover';
import AvailabilityIndicator from '../AvailabilityIndicator';
import { getStatusMessage } from '../../utils/agentStatusUtils';
import { Flex } from 'foundations-components/components/Flex';
import { useState } from 'react';
import { AvailabilityPopover } from './AvailabilityPopover';
import { useCurrentUserCapacityLimits } from '../../hooks/useUserLevelCapacityLimits';
import { useTrackUsageContextStandalone } from '../../../usage-tracking/contexts/TrackUsageContext';
import { trackAvailabilityClicked } from '../../utils/event-handlers';
import { useOutOfOfficeHours } from '../../../working-hours/hooks/useOutOfOfficeHours';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AvailabilityButton = ({
  userId,
  isAway,
  updateAwayMode
}) => {
  const tracker = useTrackUsageContextStandalone();
  const [isOpen, setIsOpen] = useState(false);
  const {
    capacity,
    loading
  } = useCurrentUserCapacityLimits();
  const {
    currentSegment
  } = useOutOfOfficeHours(userId, {
    isViewingSelf: true
  });
  const onAwayModeToggle = () => {
    updateAwayMode(!isAway);
    setIsOpen(false);
  };
  const handleClick = () => {
    trackAvailabilityClicked(tracker, isOpen);
    setIsOpen(prev => !prev);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    paddingInlineStart: "200",
    children: [/*#__PURE__*/_jsx(AvailabilityIndicator, {
      atCapacity: false,
      isAwayMode: isAway
    }), /*#__PURE__*/_jsx(Popover, {
      inlineSize: "340px",
      placement: "top right",
      open: isOpen,
      onOpenChange: e => setIsOpen(e.currentTarget.value),
      arrowSize: "none",
      content: /*#__PURE__*/_jsx(AvailabilityPopover, {
        capacity: capacity,
        isAway: isAway,
        onAwayModeToggle: onAwayModeToggle,
        currentSegment: currentSegment
      }),
      children: /*#__PURE__*/_jsxs(Button, {
        disabled: loading,
        use: "link",
        onClick: handleClick,
        "data-test-id": "availability-menu-button",
        children: [getStatusMessage(isAway), /*#__PURE__*/_jsx(DownCaratIcon, {})]
      })
    })]
  });
};
AvailabilityButton.displayName = 'AvailabilityButton';